import { RootState } from "@/app/stores"
import { getAdditionalOptions, IAddOpsResponse } from "@/shared/api/aviabooking"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchFlight = createAsyncThunk<
    IAddOpsResponse,
    string,
    { state: RootState }
>('bookFlight/fetchFlight', async (id, thunkAPI) => {
    try {
        const data = await getAdditionalOptions(id)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
